(function ($) {
    $('.open-wrap').click(function () {
        $(this).toggleClass('active');
        $('.collapse').collapse('hide');
        $('.open-wrap').not(this).removeClass('active');
    })
 
})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./src/js/investments.js
// module id = 15
// module chunks = 0